export const getProperty = (object: any, path: string, default_value = null) => {
  let pathArray: string[];
  pathArray = path.split('.');
  return pathArray.reduce(
    (xs, x) => (xs && xs[x] ? xs[x] : default_value),
    object
  );
};
